import { serverURL } from '@/utils/serverURL';
import type { VersionDetail, VersionListItem } from '@/utils/types/flavorVersion';

export async function getCurrentFormulation(
  flavorId: string,
  formulaId: number,
): Promise<VersionDetail> {
  const res = await fetch(
    serverURL`/me/flavor/${flavorId}/formulas/${formulaId}/current`,
    { credentials: 'include' },
  );
  if (!res.ok) {
    throw new Error(`flavor/${flavorId}/formulas/${formulaId}/current failed: ${res.status}`);
  }
  return (await res.json()) as VersionDetail;
}

export async function listVersions(
  flavorId: string,
  formulaId: number,
  opts: { before?: string; limit?: number } = {},
): Promise<VersionListItem[]> {
  const params = new URLSearchParams();
  if (opts.before) params.set('before', opts.before);
  if (opts.limit != null) params.set('limit', String(opts.limit));
  const qs = params.toString();
  const url = qs.length > 0
    ? serverURL`/me/flavor/${flavorId}/formulas/${formulaId}/versions?${qs}`
    : serverURL`/me/flavor/${flavorId}/formulas/${formulaId}/versions`;
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`listVersions failed: HTTP ${res.status}`);
  return (await res.json()) as VersionListItem[];
}

export async function getVersionDetail(
  flavorId: string,
  formulaId: number,
  versionId: number,
): Promise<VersionDetail> {
  const res = await fetch(
    serverURL`/me/flavor/${flavorId}/formulas/${formulaId}/versions/${versionId}`,
    { credentials: 'include' },
  );
  if (!res.ok) throw new Error(`getVersionDetail failed: HTTP ${res.status}`);
  return (await res.json()) as VersionDetail;
}

export async function restoreVersion(
  flavorId: string,
  formulaId: number,
  versionId: number,
): Promise<VersionDetail> {
  const res = await fetch(
    serverURL`/me/flavor/${flavorId}/formulas/${formulaId}/versions/${versionId}/restore`,
    { method: 'POST', credentials: 'include' },
  );
  if (!res.ok) throw new Error(`restoreVersion failed: HTTP ${res.status}`);
  return (await res.json()) as VersionDetail;
}
